<template>
  <main class="editions">
    <div class="edition" v-for="project in projects" :key="project.uid">
      <router-link :to="{ name: 'edition', params: { id: project.uid } }">
        <zoom-on-hover
          :img-normal="project.files[0].small"
          :scale="1"
        ></zoom-on-hover>
      </router-link>
      <h2>
        {{ project.title }}<br />
        {{ project.caption
        }}<span v-if="project.year">, {{ project.year }}</span
        ><br />
        {{ project.price }}€<span v-if="project.request"
          >,
          <a
            target="_blank"
            :href="
              'mailto:order@estellebourdet.com?subject=' +
                project.title +
                '&body=' +
                msg
            "
            >BUY</a
          ></span
        ><span v-else>, SOLD</span>
      </h2>
    </div>
  </main>
</template>

<script>
import zoomOnHover from "@/components/Zoom";
export default {
  components: {
    zoomOnHover: zoomOnHover
  },
  data() {
    return {
      msg:
        "Hello,%0A%0AI am interested about the weaving named above and would be pleased to receive further information on payment and delivery. Please find my details below.%0A%0AName: (First Name, Last Name)%0AAddress: (Street, City, Postal code, Country)%0APhone:%0A%0AI am looking forward to hear from you.%0ABest wishes%0A"
    };
  },
  computed: {
    projects() {
      var editions = this.$store.state.editions;
      var filtered = editions.filter(edition => {
        return edition.uid !== this.$route.params.id;
      });
      return filtered.slice(0, 12);
    }
  }
};
</script>

<style lang="scss" scoped>
.editions {
  height: auto !important;
  display: grid !important;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 1em;
  margin-bottom: 4em !important;
  @media only screen and (max-width: 768px) {
    grid-template-columns: repeat(1, 1fr);
  }
  .edition {
    grid-column: span 1;
    margin-bottom: 4em;
    h2 {
      text-align: left;
    }
    img {
      width: 100%;
      height: 30vw;
      object-fit: cover;
      margin-bottom: 0.5em;
      @media only screen and (max-width: 768px) {
        object-fit: contain;
        height: 100%;
      }
    }
  }
}
</style>
